export default __webpack_public_path__ + "static/media/ipbg.bdbd03a2.jpg";